import React from 'react';

interface BannerProps {
  title: string;
  subtitle?: string;
  imageUrl: string;
  className?: string;
  actions?: React.ReactNode;
}

const Banner: React.FC<BannerProps> = ({ 
  title, 
  subtitle, 
  imageUrl, 
  className = 'style2',
  actions 
}) => {
  return (
    <section id="banner" className={className}>
      <span className="image">
        <img src={imageUrl} alt="" />
      </span>
      <div className="inner">
        <header className="major">
          <h1>{title}</h1>
        </header>
        {subtitle && (
          <div className="content">
            <p>{subtitle}</p>
          </div>
        )}
        {actions && (
          <div>
            {actions}
          </div>
        )}
      </div>
    </section>
  );
};

export default Banner;
